import React from "react";
import SitePage from "../SitePage";
import { ShieldCheck, BadgeCheck, Award } from "lucide-react";

export default function AutenticitaPage() {
  const brands = [
    "Bandai", "Kotobukiya", "ABYstyle", "Banpresto", "Prime 1 Studio", "First 4 Figures",
    "McFarlane", "Good Smile Company", "Megahouse", "Sideshow", "Iron Studios", "Sen-Ti-Nel",
  ];

  return (
    <SitePage
      testId="autenticita-page"
      breadcrumb="Help"
      breadcrumbLabel="Autenticità"
      eyebrow="AUTENTICITÀ / 正規品"
      title="100%"
      accent="originale"
      subtitle="Ogni singolo pezzo entra in bottega solo dopo aver superato tre controlli: fornitore autorizzato, licenza attiva, ologramma sull&apos;etichetta. Se un editore ci nega la fornitura ufficiale, quel prodotto non lo trattiamo. Punto."
    >
      <div className="space-y-14 text-zinc-300 leading-relaxed">
        {/* 3 pillars */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {[
            { icon: BadgeCheck, title: "Distributori ufficiali", text: "Compriamo solo da distributori italiani o europei con contratto di licenza attivo. Nessun grigio, nessun canale parallelo." },
            { icon: ShieldCheck, title: "Sigilli originali", text: "Le scatole arrivano ancora nel loro cellophane. Se rompiamo il sigillo per fare il quality check, mettiamo un adesivo &quot;aperta per verifica&quot; e ne parliamo prima di spedirla." },
            { icon: Award, title: "Numerazione dichiarata", text: "Le edizioni limitate vengono vendute con il numero di serie ufficiale. Se un pezzo è 234/500, sull&apos;etichetta trovi scritto proprio quello." },
          ].map(({ icon: Icon, title, text }) => (
            <div key={title} className="bg-zinc-900/40 border-2 border-zinc-800 hover:border-yellow-400 transition p-6">
              <div className="bg-yellow-400 text-black p-2.5 w-11 h-11 flex items-center justify-center mb-4">
                <Icon className="w-5 h-5" strokeWidth={3} />
              </div>
              <div className="font-heading uppercase text-white text-lg mb-2">{title}</div>
              <p className="text-zinc-400 text-sm" dangerouslySetInnerHTML={{ __html: text }} />
            </div>
          ))}
        </div>

        {/* Brands */}
        <div data-testid="autenticita-brand-grid">
          <div className="font-jp text-yellow-400 text-sm tracking-widest mb-4">EDITORI CHE TRATTIAMO</div>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
            {brands.map((b) => (
              <div key={b} className="bg-zinc-900/60 border border-zinc-800 hover:border-yellow-400 transition p-3 text-center font-heading uppercase text-xs tracking-widest text-zinc-300 hover:text-yellow-400">
                {b}
              </div>
            ))}
          </div>
        </div>

        {/* Cosa NON facciamo */}
        <div className="border-l-4 border-red-500 pl-6">
          <div className="font-jp text-red-400 text-sm tracking-widest mb-3">COSA NON TROVI DA NOI</div>
          <ul className="space-y-2">
            <li>· Cloni, KO (knock-off) e ricast asiatici</li>
            <li>· Bootleg di edizioni esaurite venduti come &quot;versione europea&quot;</li>
            <li>· Statue &quot;custom&quot; senza licenza dell&apos;IP di riferimento</li>
            <li>· Pezzi con etichetta staccata o senza codice ufficiale</li>
          </ul>
        </div>

        {/* Garanzia */}
        <div className="text-center border-t-2 border-zinc-800 pt-10">
          <div className="inline-block border-4 border-yellow-400 p-6 bg-yellow-400/5">
            <div className="font-jp text-yellow-400 text-sm tracking-widest mb-2">GARANZIA DAITA&apos;N&apos;JACK</div>
            <div className="font-heading uppercase text-2xl text-white mb-2">Rimborso 100% se non originale</div>
            <p className="text-zinc-400 text-sm max-w-lg mx-auto">
              Se un pezzo comprato da noi risulta non originale a un controllo di autenticità del produttore, ti rimborsiamo l&apos;intero importo e ti diamo un buono da 50 €. Non ci è mai successo. Contiamo di continuare così.
            </p>
          </div>
        </div>
      </div>
    </SitePage>
  );
}
